export const NETWORK_STATUS = {
  BAD: 1,  // 延迟300ms以上
  GOOD: 2,  // 延迟100ms以内
  MODERATE: 3,  // 延迟100-300ms之间
  UNKNOWN: -1,
}
